import ApiService from "@/common/api.service";
import {
  RESET_SEARCH,
  FETCH_ARTICLES,
  FETCH_ARTICLES_WITH_FILE,
  FETCH_MORE_ARTICLES,
  ARTICLE_UPDATE,
  ARTICLE_CURRENT
} from "./actions.type";
import {
  SET_ARTICLES,
  PURGE_ARTICLES,
  UPDATE_ARTICLES,
  SET_CURRENT_ARTICLE,
  SET_ARTICLE_VISITED,
  SET_ARTICLE_OPENED,
  SET_ARTICLE_SAVED,
  SET_SEARCH_ENGINE,
  SET_SEARCH_QUERY,
  SET_SEARCH_BY_FILE,
  SET_FILTERS,
  UPDATE_FILTERED_ARTICLES,
  PURGE_SEARCH
} from "./mutations.type";

const state = {
  searchEngine: null,
  searchQuery: null,
  searchByFile: null,
  articles: [],
  filteredArticles: [],
  currentArticle: null
};

const getters = {
  articles(state) {
    return state.articles;
  },
  filteredArticles(state) {
    return state.filteredArticles;
  },
  currentArticle(state) {
    return state.currentArticle;
  },
  searchEngine(state) {
    return state.searchEngine;
  },
  searchQuery(state) {
    return state.searchQuery;
  },
  searchByFile(state) {
    return state.searchByFile;
  },
  filters(state) {
    return state.filters;
  }
};

export const actions = {
  [RESET_SEARCH]({ commit }) {
    commit(PURGE_ARTICLES);
    commit(PURGE_SEARCH);
  },
  [FETCH_ARTICLES]({ commit }, params) {
    commit(PURGE_ARTICLES);
    ApiService.setHeader();
    return ApiService.post("searchclass/query/", params)
    .then(({ data }) => {
      commit(SET_ARTICLES, data);
    })
  },
  [FETCH_ARTICLES_WITH_FILE]({ commit }, params) {
    commit(PURGE_ARTICLES);
    ApiService.setHeader();
    return ApiService.post("searchclass/file_upload/", params)
    .then(({ data }) => {
      commit(SET_ARTICLES, data);
    })
  },
  [FETCH_MORE_ARTICLES]({ commit }, params) {
    return new Promise(resolve => {
      let endpoint = 'query_next';
      if(params.searchType == 'file') {
        endpoint = 'file_next';
      }
      ApiService.setHeader();
      ApiService.post("searchclass/" + endpoint + "/", params.searchData)
      .then(({ data }) => {
        if(data == 'no more links') {
          resolve('no-more-links');
        } else {
          resolve(data);
          commit(SET_ARTICLES, data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    });
  },
  [ARTICLE_UPDATE]({ commit }, params) {
    ApiService.setHeader();
    return ApiService.update("searchclass/" + params.get('link_id') + "/detail/", params)
    .then(({ data }) => {
      commit(UPDATE_ARTICLES, data)
    })
  },
  [ARTICLE_CURRENT]({ commit }, article) {
    commit(SET_CURRENT_ARTICLE, article)
  }
}

const mutations = {
  [PURGE_ARTICLES](state) {
    state.articles = [];
    state.filteredArticles = [];
    state.currentArticle = null;
    state.filters = {
      filters: {
        tag: null,
        update: null,
        language: null,
        score: null
      },
      sort: {
        tag: null,
        update: null,
        language: null,
        score: null
      }
    };
  },
  [SET_ARTICLES](state, articles) {
    for (var i = 0; i < articles.length; i++) {
      articles[i].vueVisited = false;
      articles[i].vueOpened = false;
      articles[i].vueSaved = false;
    }
    state.articles.push.apply(state.articles, articles);
    state.filteredArticles = state.articles;
  },
  [UPDATE_ARTICLES](state, article) {
    let articles = state.articles
    for(var i = 0; i < articles.length; i++){
      if(article.link_id === articles[i].link_id){
        articles[i] = article;
        return;
      }
    }
  },
  [SET_CURRENT_ARTICLE](state, article) {
    state.currentArticle = article;
  },
  [SET_ARTICLE_VISITED](state, articleLinkId) {
    for (var i = state.articles.length - 1; i >= 0; i--) {
      if(state.articles[i].link_id == articleLinkId) {
        state.articles[i].vueVisited = true;
      }
    }
    for (var j = state.filteredArticles.length - 1; j >= 0; j--) {
      if(state.filteredArticles[j].link_id == articleLinkId) {
        state.filteredArticles[j].vueVisited = true;
      }
    }
  },
  [SET_ARTICLE_OPENED](state, articleLinkId) {
    for (var i = state.articles.length - 1; i >= 0; i--) {
      if(state.articles[i].link_id == articleLinkId) {
        state.articles[i].vueOpened = true;
      }
    }
    for (var j = state.filteredArticles.length - 1; j >= 0; j--) {
      if(state.filteredArticles[j].link_id == articleLinkId) {
        state.filteredArticles[j].vueOpened = true;
      }
    }
    if(state.currentArticle != null) {
      state.currentArticle.vueOpened = true;
    }
  },
  [SET_ARTICLE_SAVED](state, articleLinkId) {
    for (var i = state.articles.length - 1; i >= 0; i--) {
      if(state.articles[i].link_id == articleLinkId) {
        state.articles[i].vueSaved = true;
      }
    }
    for (var j = state.filteredArticles.length - 1; j >= 0; j--) {
      if(state.filteredArticles[j].link_id == articleLinkId) {
        state.filteredArticles[j].vueSaved = true;
      }
    }
    if(state.currentArticle != null) {
      state.currentArticle.vueSaved = true;
    }
  },
  [SET_SEARCH_ENGINE](state, searchEngine) {
    state.searchEngine = searchEngine;
  },
  [SET_SEARCH_QUERY](state, searchQuery) {
    state.searchQuery = searchQuery;
  },
  [SET_SEARCH_BY_FILE](state, searchByFile) {
    state.searchByFile = searchByFile;
  },
  [SET_FILTERS](state, filters) {
    state.filters = filters;
  },
  [UPDATE_FILTERED_ARTICLES](state, articles) {
    state.filteredArticles = articles;
  },
  [PURGE_SEARCH](state) {
    state.searchEngine = null;
    state.searchQuery = null;
    state.searchByFile = null;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};